module.exports = __webpack_public_path__ + "static/media/BW-Scroll.a01d1c0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BW-Scroll.mp4
// module id = GLmv
// module chunks = 1